import { PostnatalDiscussionTopic } from "./PostnatalDiscussionTopic";

class OntarioObstetricalPostnatalDiscussionTopics {
    public TransitionToParenthoodOrPartnerAdjustment: PostnatalDiscussionTopic;
    public FamilyViolenceAndSafety: PostnatalDiscussionTopic;
    public NutritionOrPhysicialActivityOrHealthyWeight: PostnatalDiscussionTopic;
    public PlanForAlcoholTobaccoSubstanceUseManagement: PostnatalDiscussionTopic;
    public Contraception: PostnatalDiscussionTopic;
    public PelvicFloorExercises: PostnatalDiscussionTopic;
    public CommunityResources: PostnatalDiscussionTopic;
    public AdviceRegardingFuturePregnanciesAndRisk: PostnatalDiscussionTopic;
    public PreconceptionPlanning: PostnatalDiscussionTopic;
    public CaesareanSectionFutureModeOfBirth: PostnatalDiscussionTopic;
    public OtherCommentsOrConcerns: PostnatalDiscussionTopic;

    public constructor(fields?: Partial<OntarioObstetricalPostnatalDiscussionTopics>) {
        Object.assign(this, fields);
        this.TransitionToParenthoodOrPartnerAdjustment = new PostnatalDiscussionTopic(fields?.TransitionToParenthoodOrPartnerAdjustment);
        this.FamilyViolenceAndSafety = new PostnatalDiscussionTopic(fields?.FamilyViolenceAndSafety);
        this.NutritionOrPhysicialActivityOrHealthyWeight = new PostnatalDiscussionTopic(fields?.NutritionOrPhysicialActivityOrHealthyWeight);
        this.PlanForAlcoholTobaccoSubstanceUseManagement = new PostnatalDiscussionTopic(fields?.PlanForAlcoholTobaccoSubstanceUseManagement);
        this.Contraception = new PostnatalDiscussionTopic(fields?.Contraception);
        this.PelvicFloorExercises = new PostnatalDiscussionTopic(fields?.PelvicFloorExercises);
        this.CommunityResources = new PostnatalDiscussionTopic(fields?.CommunityResources);
        this.AdviceRegardingFuturePregnanciesAndRisk = new PostnatalDiscussionTopic(fields?.AdviceRegardingFuturePregnanciesAndRisk);
        this.PreconceptionPlanning = new PostnatalDiscussionTopic(fields?.PreconceptionPlanning);
        this.CaesareanSectionFutureModeOfBirth = new PostnatalDiscussionTopic(fields?.CaesareanSectionFutureModeOfBirth);
        this.OtherCommentsOrConcerns = new PostnatalDiscussionTopic(fields?.OtherCommentsOrConcerns);
    }
}

export { OntarioObstetricalPostnatalDiscussionTopics };
